// extracted by mini-css-extract-plugin
module.exports = {"onboardingOwner":"OnboardingOwner_onboardingOwner__1w-QM","hide":"OnboardingOwner_hide__2nMEi","content":"OnboardingOwner_content__2xsUM"};